export default __webpack_public_path__ + "static/media/rotate-solid.20157f87.svg";